// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"b4aa93f6","224":"924de91f","354":"930dc940","586":"697132cf"}[chunkId] + ".chunk.js";
};